<!-- Wrapper principale che occupa tutto lo schermo -->
<div class="layout-wrapper">
  <!--
    WCAG 2.4.1: Skip link — the click handler prevents Angular Router from intercepting the
    fragment href and navigating away; instead we manually focus the <main> element.
  -->
  <a
    href="#main-content"
    class="skip-link"
    (click)="skipToMain($event)"
  >Vai al contenuto principale</a>
  
  <!-- Spinner di caricamento globale -->
  <app-global-loading></app-global-loading>
  
  <!-- Dialog di conferma globale -->
  <p-confirmDialog role="alertdialog" aria-modal="true"></p-confirmDialog>
  
  <!-- Toast per notifiche globali (sessione, errori, etc) -->
  <p-toast role="status" aria-live="polite" aria-atomic="true"></p-toast>
  
  <!-- L'Header DEVE stare fuori dal contenitore Flex per occupare il 100% in alto -->
  @if (showHeader()) {
    <app-headerbar></app-headerbar>
  }

  <!-- Questo contenitore gestisce il "sotto-header": Navbar a sx e Contenuto a dx -->
  <div class="layout-container">
    <!-- Sidebar a sinistra -->
    @if (showNavbar()) {
      <aside class="navbar-wrapper" [class.collapsed]="isSidebarCollapsed">
        <app-navbar
          [collapsedState]="isSidebarCollapsed"
          (sidebarCollapsedChange)="onSidebarCollapsedChange($event)"
        ></app-navbar>
      </aside>
    }

    <!-- Area dinamica del router a destra -->
    <!-- tabindex="-1" allows programmatic focus from the skip link without being a tab stop -->
    <main id="main-content" class="content-area" [class.full-width]="!showNavbar()" tabindex="-1">
      <router-outlet></router-outlet>
    </main>
  </div>
  <app-footer></app-footer>
</div>
